import 'angular-datamaps';
import 'angular-nvd3';
import 'angular-recursion';
import refineColumns from './refineColumns';
import refineDistributions from './refineDistributions/refineDistributions';
import refineTimeframe from './refineTimeframe/refineTimeframe';
import displayTimeframe from './displayTimeframe/displayTimeframe';
import refineDataviews from './refineDataviews/refineDataviews';
import sidebarBlockHeader from './sidebarBlockHeader/sidebarBlockHeader';
import navTabs from './navTabs/navTabs';
import linechart from './linechart/linechart';
import chartLegend from './chartLegend/chartLegend';
import saveAsImage from './saveAsImage/saveAsImage';
import footnotes from './footnotes/footnotes';
import notes from './notes/notes';

export default angular
  .module('datacenterDirectives', [
    'ngAnimate',
    'datamaps',
    'RecursionHelper',
    'nvd3',
  ])

  .directive('datacenterRefineColumns', refineColumns)

  .directive('datacenterRefineDistributions', refineDistributions)

  .directive('datacenterRefineTimeframe', refineTimeframe)

  .directive('datacenterDisplayTimeframe', displayTimeframe)

  .directive('datacenterRefineDataviews', refineDataviews)

  .directive('datacenterTabs', navTabs)

  .directive('sidebarBlockHeader', sidebarBlockHeader)

  .directive('linechart', linechart)

  .directive('chartLegend', chartLegend)

  .directive('saveAsImage', saveAsImage)

  .directive('footnotes', footnotes)

  .directive('notes', notes)

  .name;



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/directives/directives.js
 **/